var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DC7D7E5A-FB9D-4265-85BE-DF5E7D2D1759") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1-arrow-down-blue",
    points: "14.2666667 24.9333331 16.1333333 23.0666665 10.4 17.3333333 26.6666667 17.3333333 26.6666667 14.6666667 10.4 14.6666667 16.1333333 8.93333353 14.2666667 7.06666692 5.33333333 16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page-arrow-down-blue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Back-arrow-down-blue",
    transform: "translate(16.000000, 16.000000) rotate(-90.000000) translate(-16.000000, -16.000000) "
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-arrow-down-blue",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-arrow-down-blue"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask-arrow-down-blue",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color-Mixin/Fill/Active-arrow-down-blue",
    mask: "url(#mask-2-arrow-down-blue)",
    fill: "#00B5E1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlue);
export default __webpack_public_path__ + "static/media/ArrowDownBlue.d54912e1.svg";
export { ForwardRef as ReactComponent };